export const currencyOptions = [
  { key: '1', value: 'US dollar', text: 'US dollar' },
  { key: '2', value: 'Euro', text: 'Euro' },
  { key: '3', value: 'Japanese yen', text: 'Japanese yen' },
  { key: '4', value: 'Pound sterling', text: 'Pound sterling' },
  {
    key: '5',
    value: 'United Arab Emirates dirham',
    text: 'United Arab Emirates dirham',
  },
  { key: '6', value: 'Afghan afghani', text: 'Afghan afghani' },
  { key: '7 ', value: 'Albanian lek', text: 'Albanian lek' },
  { key: '8', value: 'Armenian dram', text: 'Armenian dram' },
  {
    key: '9',
    value: 'Netherlands Antillean guilder',
    text: 'Netherlands Antillean guilder',
  },
  { key: '10', value: 'Angolan kwanza', text: 'Angolan kwanza' },
  { key: '11', value: 'Argentine peso', text: 'Argentine peso' },
  { key: '12', value: 'Australian dollar', text: 'Australian dollar' },
  { key: '13', value: 'Aruban florin', text: 'Aruban florin' },
  { key: '14', value: 'Azerbaijani manat', text: 'Azerbaijani manat' },
  {
    key: '15',
    value: 'Bosnia and Herzegovina convertible mark',
    text: 'Bosnia and Herzegovina convertible mark',
  },
  { key: '16', value: 'Barbadian dollar', text: 'Barbadian dollar' },
  { key: '17', value: 'Bangladeshi taka', text: 'Bangladeshi taka' },
  { key: '18', value: 'Bulgarian lev', text: 'Bulgarian lev' },
  { key: '19', value: 'Bahraini dinar', text: 'Bahraini dinar' },
  { key: '20', value: 'Burundian franc', text: 'Burundian franc' },
  { key: '21', value: 'Bermudian dollar', text: 'Bermudian dollar' },
  { key: '22', value: 'Brunei dollar', text: 'Brunei dollar' },
  { key: '23', value: 'Bolivian boliviano', text: 'Bolivian boliviano' },
  { key: '24', value: 'Brazilian real', text: 'Brazilian real' },
  { key: '25', value: 'Bahamian dollar', text: 'Bahamian dollar' },
  { key: '26', value: 'Bhutanese ngultrum', text: 'Bhutanese ngultrum' },
  { key: '27', value: 'Botswana pula', text: 'Botswana pula' },
  { key: '28', value: 'Belarusian ruble', text: 'Belarusian ruble' },
  { key: '29', value: 'Belize dollar', text: 'Belize dollar' },
  { key: '30', value: 'Canadian dollar', text: 'Canadian dollar' },
  { key: '31', value: 'Congolese franc', text: 'Congolese franc' },
  { key: '32', value: 'Swiss franc', text: 'Swiss franc' },
  { key: '33', value: 'Chilean peso', text: 'Chilean peso' },
  { key: '34', value: 'Chinese yuan', text: 'Chinese yuan' },
  { key: '35', value: 'Colombian peso', text: 'Colombian peso' },
  { key: '36', value: 'Costa Rican colon', text: 'Costa Rican colon' },
  {
    key: '37',
    value: 'Cuban convertible peso',
    text: 'Cuban convertible peso',
  },
  { key: '38', value: 'Cuban peso', text: 'Cuban peso' },
  { key: '39', value: 'Cape Verdean escudo', text: 'Cape Verdean escudo' },
  { key: '40', value: 'Czech koruna', text: 'Czech koruna' },
  { key: '41', value: 'Djiboutian franc', text: 'Djiboutian franc' },
  { key: '42', value: 'Danish krone', text: 'Danish krone' },
  { key: '43', value: 'Dominican peso', text: 'Dominican peso' },
  { key: '44', value: 'Algerian dinar', text: 'Algerian dinar' },
  { key: '45', value: 'Egyptian pound', text: 'Egyptian pound' },
  { key: '46', value: 'Eritrean nakfa', text: 'Eritrean nakfa' },
  { key: '47', value: 'Ethiopian birr', text: 'Ethiopian birr' },
  { key: '48', value: 'EURO', text: 'EURO' },
  { key: '49', value: 'Fijian dollar', text: 'Fijian dollar' },
  {
    key: '50',
    value: 'Falkland Islands pound',
    text: 'Falkland Islands pound',
  },
  { key: '51', value: 'British pound', text: 'British pound' },
  { key: '52', value: 'Georgian lari', text: 'Georgian lari' },
  { key: '53', value: 'Guernsey pound', text: 'Guernsey pound' },
  { key: '54', value: 'Ghanaian cedi', text: 'Ghanaian cedi' },
  { key: '55', value: 'Gibraltar pound', text: 'Gibraltar pound' },
  { key: '56', value: 'Gambian dalasi', text: 'Gambian dalasi' },
  { key: '57', value: 'Guinean franc', text: 'Guinean franc' },
  { key: '58', value: 'Guatemalan quetzal', text: 'Guatemalan quetzal' },
  { key: '59', value: 'Guyanese dollar', text: 'Guyanese dollar' },
  { key: '60', value: 'Hong Kong dollar', text: 'Hong Kong dollar' },
  { key: '61', value: 'Honduran lempira', text: 'Honduran lempira' },
  { key: '62', value: 'Hong Kong dollar', text: 'Hong Kong dollar' },
  { key: '63', value: 'Croatian kuna', text: 'Croatian kuna' },
  { key: '64', value: 'Haitian gourde', text: 'Haitian gourde' },
  { key: '65', value: 'Hungarian forint', text: 'Hungarian forint' },
  { key: '66', value: 'Indonesian rupiah', text: 'Indonesian rupiah' },
  { key: '67', value: 'Israeli new shekel', text: 'Israeli new shekel' },
  { key: '68', value: 'Manx pound', text: 'Manx pound' },
  { key: '69', value: 'Indian rupee', text: 'Indian rupee' },
  { key: '70', value: 'Iraqi dinar', text: 'Iraqi dinar' },
  { key: '71', value: 'Iranian rial', text: 'Iranian rial' },
  { key: '72', value: 'Icelandic króna', text: 'Icelandic króna' },
  { key: '73', value: 'Jersey pound', text: 'Jersey pound' },
  { key: '74', value: 'Jamaican dollar', text: 'Jamaican dollar' },
  { key: '75', value: 'Jordanian dinar', text: 'Jordanian dinar' },
  { key: '76', value: 'Japanese yen', text: 'Japanese yen' },
  { key: '77', value: 'Kenyan shilling', text: 'Kenyan shilling' },
  // { key:'USA',value:"Kyrgyzstani som" ,text:"Kyrgyzstani som"},
  // { key:'USA',value:"Cambodian riel" ,text:"Cambodian riel"},
  // { key:'USA',value:"Kiribati dollar" ,text:"Kiribati dollar"},
  // { key:'USA',value:"Comorian franc" ,text:"Comorian franc"},
  // { key:'USA',value:"North Korean won" ,text:"North Korean won"},
  // { key:'USA',value:"South Korean won" ,text:"South Korean won"},
  // { key:'USA',value:"Kuwaiti dinar" ,text:"Kuwaiti dinar"},
  // { key:'USA',value:"Cayman Islands dollar" ,text:"Cayman Islands dollar"},
  // { key:'USA',value:"Kazakhstani tenge" ,text:"Kazakhstani tenge"},
  // { key:'USA',value:"Lao kip" ,text:"Lao kip"},
  // { key:'USA',value:"Lebanese pound" ,text:"Lebanese pound"},
  // { key:'USA',value:"Sri Lankan rupee" ,text:"Sri Lankan rupee"},
  // { key:'USA',value:"Liberian dollar" ,text:"Liberian dollar"},
  // { key:'USA',value:"Lesotho loti" ,text:"Lesotho loti"},
  // { key:'USA',value:"Libyan dinar" ,text:"Libyan dinar"},
  // { key:'USA',value:"Moroccan dirham" ,text:"Moroccan dirham"},
  // { key:'USA',value:"Moldovan leu" ,text:"Moldovan leu"},
  // { key:'USA',value:"Malagasy ariary" ,text:"Malagasy ariary"},
  // { key:'USA',value:"Macedonian denar" ,text:"Macedonian denar"},
  // { key:'USA',value:"Burmese kyat" ,text:"Burmese kyat"},
  // { key:'USA',value:"Mongolian tögrög" ,text:"Mongolian tögrög"},
  // { key:'USA',value:"Macanese pataca" ,text:"Macanese pataca"},
  // { key:'USA',value:"Mauritanian ouguiya" ,text:"Mauritanian ouguiya"},
  // { key:'USA',value:"Mauritian rupee" ,text:"Mauritian rupee"},
  // { key:'USA',value:"Maldivian rufiyaa" ,text:"Maldivian rufiyaa"},
  // { key:'USA',value:"Malawian kwacha" ,text:"Malawian kwacha"},
  // { key:'USA',value:"Mexican peso" ,text:"Mexican peso"},
  // { key:'USA',value:"Malaysian ringgit" ,text:"Malaysian ringgit"},
  // { key:'USA',value:"Mozambican metical" ,text:"Mozambican metical"},
  // { key:'USA',value:"Namibian dollar" ,text:"Namibian dollar"},
  // { key:'USA',value:"Nigerian naira" ,text:"Nigerian naira"},
  // { key:'USA',value:"Nicaraguan córdoba" ,text:"Nicaraguan córdoba"},
  // { key:'USA',value:"Norwegian krone" ,text:"Norwegian krone"},
  // { key:'USA',value:"Nepalese rupee" ,text:"Nepalese rupee"},
  // { key:'USA',value:"New Zealand dollar" ,text:"New Zealand dollar"},
  // { key:'USA',value:"Omani rial" ,text:"Omani rial"},
  // { key:'USA',value:"Panamanian balboa" ,text:"Panamanian balboa"},
  // { key:'USA',value:"Peruvian sol" ,text:"Peruvian sol"},
  // { key:'USA',value:"Papua New Guinean kina" ,text:"Papua New Guinean kina"},
  // { key:'USA',value:"Philippine peso" ,text:"Philippine peso"},
  // { key:'USA',value:"Pakistani rupee" ,text:"Pakistani rupee"},
  // { key:'USA',value:"Polish złoty" ,text:"Polish złoty"},
  // { key:'USA',value:"Transnistrian ruble" ,text:"Transnistrian ruble"},
  // { key:'USA',value:"Paraguayan guaraní" ,text:"Paraguayan guaraní"},
  // { key:'USA',value:"Qatari riyal" ,text:"Qatari riyal"},
  // { key:'USA',value:"Romanian leu" ,text:"Romanian leu"},
  // { key:'USA',value:"Serbian dinar" ,text:"Serbian dinar"},
  // { key:'USA',value:"Russian ruble" ,text:"Russian ruble"},
  // { key:'USA',value:"Rwandan franc" ,text:"Rwandan franc"},
  // { key:'USA',value:"Saudi riyal" ,text:"Saudi riyal"},
  // { key:'USA',value:"Swedish krona" ,text:"Swedish krona"},
  // { key:'USA',value:"Singapore dollar" ,text:"Singapore dollar"},
  // { key:'USA',value:"Saint Helena pound" ,text:"Saint Helena pound"},
  // { key:'USA',value:"Sierra Leonean leone" ,text:"Sierra Leonean leone"},
  // { key:'USA',value:"Somaliland shilling" ,text:"Somaliland shilling"},
  // { key:'USA',value:"Somali shilling" ,text:"Somali shilling"},
  // { key:'USA',value:"Surinamese dollar" ,text:"Surinamese dollar"},
  // { key:'USA',value:"South Sudanese pound" ,text:"South Sudanese pound"},
  // { key:'USA',value:"São Tomé and Príncipe dobra" ,text:"São Tomé and Príncipe dobra"},
  // { key:'USA',value:"Syrian pound" ,text:"Syrian pound"},
  // { key:'USA',value:"Swazi lilangeni" ,text:"Swazi lilangeni"},
  // { key:'USA',value:"Thai baht" ,text:"Thai baht"},
  // { key:'USA',value:"Tajikistani somoni" ,text:"Tajikistani somoni"},
  // { key:'USA',value:"Turkmenistan manat" ,text:"Turkmenistan manat"},
  // { key:'USA',value:"Tunisian dinar" ,text:"Tunisian dinar"},
  // { key:'USA',value:"Tongan paʻanga" ,text:"Tongan paʻanga"},
  // { key:'USA',value:"Turkish lira" ,text:"Turkish lira"},
  // { key:'USA',value:"Trinidad and Tobago dollar" ,text:"Trinidad and Tobago dollar"},
  // { key:'USA',value:"Tuvaluan dollar" ,text:"Tuvaluan dollar"},
  // { key:'USA',value:"New Taiwan dollar" ,text:"New Taiwan dollar"},
  // { key:'USA',value:"Tanzanian shilling" ,text:"Tanzanian shilling"},
  // { key:'USA',value:"Ukrainian hryvnia" ,text:"Ukrainian hryvnia"},
  // { key:'USA',value:"Ugandan shilling" ,text:"Ugandan shilling"},
  { key: '78', value: 'United States dollar', text: 'United States dollar' },
  // { key:'USA',value:"Uruguayan peso" ,text:"Uruguayan peso"},
  // { key:'USA',value:"Uzbekistani soʻm" ,text:"Uzbekistani soʻm"},
  // { key:'USA',value:"Venezuelan bolívar soberano" ,text:"Venezuelan bolívar soberano"},
  // { key:'USA',value:"Vietnamese đồng" ,text:"Vietnamese đồng"},
  // { key:'USA',value:"Vanuatu vatu" ,text:"Vanuatu vatu"},
  // { key:'USA',value:"Samoan tālā" ,text:"Samoan tālā"},
  // { key:'USA',value:"Central African CFA franc" ,text:"Central African CFA franc"},
  // { key:'USA',value:"Eastern Caribbean dollar" ,text:"Eastern Caribbean dollar"},
  // { key:'USA',value:"West African CFA franc" ,text:"West African CFA franc"},
  // { key:'USA',value:"CFP franc" ,text:"CFP franc"},
  // { key:'USA',value:"South African rand" ,text:"South African rand"},
  // { key:'USA',value:"Zambian kwacha" ,text:"Zambian kwacha"},
  // { key:'USA',value:"Zimbabwean bonds" ,text:"Zimbabwean bonds"},
];
